import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, catchError, tap, throwError } from "rxjs";
import { Utils } from "../utils/utils";

export interface EnergyConsumptionReportConfiguration {
    tenantId?: string;
    controllerType: string;
    enable: boolean;
    sendInterval: string;
    reportingInterval: number;
}

@Injectable()
export class EnergyConsumptionReportConfigurationService {
    private readonly configurationUrl: string;
    private readonly controllerTypeUrl: string;
    private readonly baseUrl: string;

    constructor(
        private readonly httpClient: HttpClient,
        @Inject('BASE_URL') baseUrl: string
    ) {
        this.baseUrl = baseUrl;
        this.configurationUrl = `${baseUrl}api/EnergyConsumptionReportConfiguration`;
        this.controllerTypeUrl = `${baseUrl}api/controllertype`;
    }

    getAll(): Observable<EnergyConsumptionReportConfiguration[]> {
        return this.httpClient
            .get<EnergyConsumptionReportConfiguration[]>(this.configurationUrl)
            .pipe(catchError(error => this.handleError(error)));
    }

    getControllerTypes(): Observable<ControllerType[]> {
        return this.httpClient
            .get<ControllerType[]>(`${this.controllerTypeUrl}/all`)
            .pipe(tap(controllerTypes => console.log("Controller types:", controllerTypes)))
            .pipe(catchError(error => this.handleError(error)));
    }

    upsert(configuration: EnergyConsumptionReportConfiguration): Observable<EnergyConsumptionReportConfiguration> {
        return this.httpClient
            .put<EnergyConsumptionReportConfiguration>(this.configurationUrl, configuration)
            .pipe(catchError(error => this.handleError(error)));
    }

    delete(configuration: EnergyConsumptionReportConfiguration): Observable<void> {
        return this.httpClient
            .delete<void>(this.configurationUrl, { body: configuration })
            .pipe(catchError(error => this.handleError(error)));
    }

    private handleError(error: any) {
        Utils.writeLog(this.httpClient, this.baseUrl, error);
        return throwError(() => error);
    }
}